import React from "react"
import { Payment } from "@ssc-booking/api-contracts"
import { match } from "ts-pattern"
import { CybersourcePaymentModal } from "./CybersourcePaymentModal"
import { DemetraPaymentModal } from "./DemetraPaymentModal"

type Props = {
    iframeName: string
    payment: Payment
    closeModal: () => void
}

const PaymentModal: React.FC<React.PropsWithChildren<Props>> = ({ payment, iframeName, closeModal }) => {
    return match(payment)
        .with({ type: "cybersource" }, (payment) => (
            <CybersourcePaymentModal payment={payment} iframeName={iframeName} closeModal={closeModal} />
        ))
        .with({ type: "demetra" }, (payment) => (
            <DemetraPaymentModal payment={payment} iframeName={iframeName} closeModal={closeModal} />
        ))
        .exhaustive()
}

export default PaymentModal
